export function convertDate(date: string) {

  return date ? new Date(date) : null;
}

export function convertDateUTC(date: string) {

  return date ? new Date(date+".00Z") : null;
}

export function dateFormat(date: Date) {

  return date ? date.toLocaleString() : null;
}
